export default __webpack_public_path__ + "static/media/bell.d35f5b49.svg";